var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H30C40.86 2.5 45.5 7.14 45.5 18V30C45.5 40.86 40.86 45.5 30 45.5ZM18 5.5C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V18C42.5 8.78 39.22 5.5 30 5.5H18Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.5C19.32 32.5 15.5 28.68 15.5 24C15.5 19.32 19.32 15.5 24 15.5C28.68 15.5 32.5 19.32 32.5 24C32.5 28.68 28.68 32.5 24 32.5ZM24 18.5C20.96 18.5 18.5 20.96 18.5 24C18.5 27.04 20.96 29.5 24 29.5C27.04 29.5 29.5 27.04 29.5 24C29.5 20.96 27.04 18.5 24 18.5Z",
    fill: "#FF9C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15.0001C33.74 15.0001 33.48 14.9401 33.24 14.8401C33 14.7401 32.78 14.6001 32.58 14.4201C32.4 14.2201 32.24 14.0001 32.14 13.7601C32.04 13.5201 32 13.2601 32 13.0001C32 12.7401 32.04 12.4801 32.14 12.2401C32.26 11.9801 32.4 11.7801 32.58 11.5801C32.68 11.5001 32.78 11.4001 32.88 11.3401C33 11.2601 33.12 11.2001 33.24 11.1601C33.36 11.1001 33.48 11.0601 33.62 11.0401C34.26 10.9001 34.94 11.1201 35.42 11.5801C35.6 11.7801 35.74 11.9801 35.84 12.2401C35.94 12.4801 36 12.7401 36 13.0001C36 13.2601 35.94 13.5201 35.84 13.7601C35.74 14.0001 35.6 14.2201 35.42 14.4201C35.22 14.6001 35 14.7401 34.76 14.8401C34.52 14.9401 34.26 15.0001 34 15.0001Z",
    fill: "#FF9C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6b060536ef1dee984bbdcfce9f19c4ac.svg";
export { ForwardRef as ReactComponent };